import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

interface IHomeProps {
}

type HomeProps = WithStyle<ReturnType<typeof styles>, IHomeProps>;

class Home extends React.Component<HomeProps> {
  constructor(props: HomeProps) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <Typography variant='h5'>Welcome Home</Typography>
      </div>
    )} />;
  }
}

export default withStyles<IHomeProps>(styles, Home);